















































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as temp from "../../_store/temp.module";
import { InstituteInfo } from "../../_models/instituteInfo";
import { bus } from "../../main";

@Component
export default class GiorniDialog extends Vue {
  @Prop() listaGiorni!: any;
  private dialog: boolean;
  private search: string;
  private loadingData: boolean;

  private addDataGiorno: string;
  private editDataGiorno: string;
  private add: boolean;
  private edit: boolean;
  private editGiornoMenu: boolean;
  private addGiornoMenu: boolean;

  private idGiornoEdit: number;

  private data: any;
  private addGiornoFormatted: any;

  constructor() {
    super();
    this.dialog = false;
    this.search = "";
    this.loadingData = true;

    this.editDataGiorno = new Date().toISOString().substring(0, 10);
    this.addDataGiorno = new Date().toISOString().substring(0, 10);
    this.add = false;
    this.edit = false;
    this.addGiornoMenu = false;
    this.editGiornoMenu = false;
    this.addGiornoFormatted = "";

    this.idGiornoEdit = 0;
  }

  // @Watch("addDataGiorno")
  // onArticolazioneChange(value: string) {
  //   this.data = this.formatDate(this.addDataGiorno);
  //   // bus.$emit("autorizzazioneFilter", value)
  //   // console.log(this.addDataGiorno)
  //   // console.log(this.data)
  // }

  showAdd() {
    this.add = true;
  }

  closeAdd() {
    this.add = false;
    this.addDataGiorno = "";
  }

  addGiorno() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico,
      giorno: this.addDataGiorno
    };
    if (payload.giorno !== "") {
      user
        .dispatchAddGiornoWorkshop(this["$store"], payload)
        .then(() => {
          this.add = false;
          bus.$emit("successfullOperation", "Giorno aggiunto con successo");
          bus.$emit("loadGiorni");
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    } else {
      bus.$emit("errorOperation", "Inserire un valore valido come giorno");
    }
  }

  showEdit(idGiorno: number, giorno: string) {
    this.edit = true;
    this.editDataGiorno = giorno;
    this.idGiornoEdit = idGiorno;
  }

  closeEdit() {
    this.edit = false;
    this.editDataGiorno = "";
  }

  editGiorno() {
    var payload = {
      idGiorno: this.idGiornoEdit,
      giorno: this.editDataGiorno
    };
    user
      .dispatchEditGiornoWorkshop(this["$store"], payload)
      .then(() => {
        this.edit = false;
        bus.$emit("successfullOperation", "Giorno modificato con successo");
        bus.$emit("loadGiorni");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  deleteGiorno(idGiorno: number) {
    var payload = {
      idGiorno: idGiorno
    };
    user
      .dispatchDeleteGiornoWorkshop(this["$store"], payload)
      .then(() => {
        bus.$emit("successfullOperation", "Giorno eliminato con successo");
        bus.$emit("loadGiorni");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  close() {
    this.dialog = false;
    bus.$emit("loadSchedulazioneWorkshop");
  }

  // formatDate(date: any) {
  //   if (!date) return null;

  //   const [year, month, day] = date.split("-");
  //   return `${day}/${month}/${year}`;
  // }

  // parseDate(date: any) {
  //   if (!date) return null;

  //   console.log(date);
  //   const [month, day, year] = date.split("-");
  //   console.log(day, month, year);
  //   return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  // }
}
